<template>
	<div>
		<PageFirstHeader></PageFirstHeader>
		<PageHeader @updateProductType="updateProductTypeChange" @selectArea="selectArea" @serfunch="serfunch"
			@Ranking="Ranking" @allHeader="allHeader" @delKeyWord="delKeyWord" ref="headerRef">
		</PageHeader>
		<router-view :updateProductType="updateProductType" ref="myviewRef" @delHeader="delHeader" @delHeas="delHeas"
			@clearFun="clearFun"></router-view>

		<div class="sidebar">
			<div>
				<dic class="red" v-if="total">{{total}}</dic>
				<img class="sidebar-img" src="@/assets/img/message.png" @click="mess('')"></img>
				<span @click="mess('')">消息</span>
			</div>
			<div>
				<el-popover popper-class="popover" placement="right" width="152" trigger="manual"
					content="咨询热线: 400-189-1168" v-model="service">
				</el-popover>
				<img class="sidebar-img" src="@/assets/img/service.png" @click="serviceCli"></img>
				<span @click="serviceCli">客服</span>
			</div>
			<div>
				<el-popover popper-class="popover code" placement="right" width="120" trigger="manual" v-model="code">
					<img :src="`https://q7w.com.cn/zty_server/QRCode/${idaqdk}`"
						style="width: 120px;height:120px;" />
				</el-popover>
				<img class="sidebar-img" src="@/assets/img/code.png" @click="codeCli"></img>
				<span @click="codeCli">小程序<br>二维码</span>
			</div>
			<img class="sidebar-img" src="@/assets/img/feedback.png" @click="feedback"></img>
			<span @click="feedback">反馈意见</span>
			<img class="sidebar-img" src="@/assets/img/head.png" @click="head"></img>
			<span @click="head">返回顶部</span>
		</div>
		<el-dialog class="dialog" width="64%" top="9vh" :fullscreen="fullscreen" :visible.sync="message" :show-close="false">
			<template slot="title">
				<div class="tit">
					<span>消息</span>
					<div class="operation">
						<img src="@/assets/img/magnify.png" v-if="!fullscreen" @click="fullscreen = true">
						<img src="@/assets/img/reduce.png" v-else @click="fullscreen = false">
						<img src="@/assets/img/close.png" @click="message=false">
					</div>
				</div>
				<div class="chat" :style="{height:fullscreen?'90vh':'74vh'}">
					<iframe id="tui-iframe" src="https://q7w.com.cn/zty_chat" frameborder="0"
						style="width: 100%;height: 100%;"></iframe>
				</div>
			</template>
		</el-dialog>
		<el-dialog width="70%" :visible.sync="isLink" :show-close="false">
			<template slot="title">
				<div class="tit">
					<span>发送链接</span>
					<div class="operation">
						<img src="@/assets/img/close.png" @click="isLink=false">
					</div>
				</div>
			</template>
			<search ref="search" :uid="uid" :firmId="firmId" @link="link"></search>
		</el-dialog>
		<PageFooter></PageFooter>
		<iframe id="init" src="https://q7w.com.cn/zty_chat" frameborder="0"
			style="position:absolute;width: 0;height: 0;"></iframe>
	</div>
</template>

<script>
	import PageFirstHeader from "@/components/PageFirstHeader.vue";
	import PageHeader from '@/components/PageHeader.vue'
	import PageFooter from '@/components/PageFooter.vue'
	import search from './search.vue'
	import {
		getQRImg,
		getFirmInfo
	} from '@/api/user.js';
	import {
		EventBus
	} from '@/utils/event-bus';
	export default {
		name: "Layout",
		components: {
			PageFirstHeader,
			PageHeader,
			PageFooter,
			search
		},
		data() {
			return {
				updateProductType: "",
				timer: null,
				fullscreen: false, //聊天全屏
				message: false, //聊天弹窗
				service: false, //客服弹窗
				code: false, //二维码弹窗
				idaqdk: '', //二维码
				isLink: false, //发送商品弹窗
				firmId: '', //对方店铺id
				total: 0, //消息数量
				uid: '', //对方id 发送商品需要传入
			};
		},
		created() {
			setTimeout(() => {
				this.init()
			}, 1000)
			this.getQRImg()
			window.addEventListener('message', (event) => {
				if (event.data.link) { //发送链接弃用
					this.isLink = event.data.link //显示发送商品弹窗
					setTimeout(() => {
						this.$refs.search.queryParams.putType = 1
						this.$refs.search.queryParams.content = ''
						this.$refs.search.getList(true)
					})
					this.uid = event.data.uid
				}
				if (event.data.firmId) this.firmId = event.data.firmId //商铺id
				if (event.data.pid) { //跳转商品详情
					// this.message = false
					// this.$router.push({
					// 	path: "/productDetail/" + this.$route.name,
					// 	query: {
					// 		id: event.data.pid,
					// 		filters: JSON.stringify({
					// 			pageNo: 1
					// 		}) // 序列化对象
					// 	}
					// });
					const routeUrl = this.$router.resolve({
						path: "/productDetail/" + this.$route.name,
						query: {
							id: event.data.pid,
							filters: JSON.stringify({
								pageNo: 1
							})
						}
					});
					window.open(routeUrl.href, "_blank");
				}
				console.log(event.data.total,'新消息')
				if (event.data.total || event.data.total === 0) this.total = event.data.total //消息数量
			});
			EventBus.$on('mess', (msg) => {
				// this.mess(msg.uid, msg.firmid) //详情过来 显示聊天
				this.mess(msg.uid, msg.data) //详情过来 显示聊天
			});
			EventBus.$on('init', (msg) => {
				this.init() //初始化 为了消息数量
			});
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
			clearInterval(this.timer)
			EventBus.$off('mess'); // 清理事件监听器，避免内存泄漏
		},
		methods: {
			serviceCli() { //客服
				this.code = false
				this.service = !this.service
			},
			codeCli() { //二维码
				this.service = false
				this.code = !this.code
			},
			handleScroll() { //滑动弹窗关闭
				this.code = false
				this.service = false
			},
			init() { //初始化
				if (!localStorage.getItem('token')) return;
				let data = JSON.parse(localStorage.getItem('userInfo'))
				if (data.isFirm == 1) {
					getFirmInfo().then(res => {
						let iframe = document.getElementById('init')
						let params = {
							id: data.id,
							nickname: res.result.firmName,
							avatar: res.result.firmImgs,
						}
						iframe.contentWindow.postMessage(JSON.stringify(params), '*');
					})
				} else {
					let iframe = document.getElementById('init')
					console.log(iframe, 'iframe')
					let params = {
						id: data.id,
						nickname: data.nickname,
						avatar: data.avatar,
					}
					iframe.contentWindow.postMessage(JSON.stringify(params), '*');
				}
			},
			mess(str = '', goods = '') { //登录
				if (!localStorage.getItem('token')) return this.goLogin()
				this.message = true
				let data = JSON.parse(localStorage.getItem('userInfo'))
				if (data.isFirm == 1) {
					getFirmInfo().then(res => {
						let iframe = document.getElementById('tui-iframe')
						let params = {
							id: data.id,
							nickname: res.result.firmName,
							avatar: res.result.firmImgs,
							uid: str
						}
						if (goods) params.goods = goods
						iframe.contentWindow.postMessage(JSON.stringify(params), '*');
					})
				} else {
					let iframe = document.getElementById('tui-iframe')
					let params = {
						id: data.id,
						nickname: data.nickname,
						avatar: data.avatar,
						uid: str
					}
					if (goods) params.goods = goods
					iframe.contentWindow.postMessage(JSON.stringify(params), '*');
				}
			},
			getQRImg() {
				getQRImg({}).then(res => {
					this.idaqdk = res.result
				})
			},
			feedback() {
				if (!localStorage.getItem('token')) return this.goLogin()
				this.$router.push('/feedback')
			},
			head() {
				window.scrollTo({
					behavior: 'smooth',
					top: 0
				})
			},
			goLogin() { //游客模式提示弹窗
				this.$confirm('您还未登录，请登陆后浏览', '确认信息', {
						distinguishCancelAndClose: true,
						confirmButtonText: '去登陆',
						cancelButtonText: '取消'
					})
					.then(() => {
						this.$router.push('/login')
					})
			},
			link(data) { //发送商品数据
				let iframe = document.getElementById('tui-iframe')
				iframe.contentWindow.postMessage(JSON.stringify(data), '*');
				this.isLink = false
			},
			selectArea(obj) { //新增地址筛选
				// this.$nextTick(() => {
				// DOM更新后执行的代码
				this.$refs.myviewRef.Filtercities({
					name: obj.name,
					code: obj.code
				});
				// });
			},

			allHeader(type) {
				this.$refs.myviewRef.isNes = true
				this.$nextTick(() => {
					// console.log(`key:${type.key},name:${type.name}  22`);

					this.timer = setInterval(() => {
						try {
							this.$refs.myviewRef.allHeader({
								categoryId: type.key,
								names: type.name
							})
							clearInterval(this.timer)
						} catch (error) {}

					}, 100);

					setTimeout(() => {
						clearInterval(this.timer)
					}, 3000);
				})

			},
			updateProductTypeChange(e) {
				this.updateProductType = String(e);
			},
			// method
			serfunch(obj) {
				this.$nextTick(() => {
					// DOM更新后执行的代码
					this.$refs.myviewRef.myviewFun({
						name: obj.keywords
					});
				});

			},
			Ranking(obj) { //分类筛选  商家排行
				this.$refs.myviewRef.searchRanking(obj.mainBusiness);
			},
			delKeyWord() {
				this.$refs.myviewRef.delKeyWord()
			},

			clearFun() {
				this.$refs.headerRef.headerRefFun()
			},
			delHeader() {
				this.$refs.headerRef.delHeader()
			},
			delHeas(type) {
				this.$refs.headerRef.delHeas(type)

			},
		},

	};
</script>

<style lang="scss">
	.dialog {
		.el-dialog {
			.el-dialog__header {
				padding: 20px
			}

			.el-dialog__body {
				padding: 0;
			}
		}
	}

	.popover {
		position: absolute !important;
		top: 20px;
		right: 75px;
	}

	.code {
		min-width: 80px;
		top: 6px;
	}

	/* scoped css */
	.sidebar {
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		right: 20px;
		padding: 0 10px 28px;
		width: 72px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FFFFFF;
		box-sizing: border-box;
		box-shadow: 0px 4px 12px 1px rgba(254, 90, 19, 0.2);
		border-radius: 50px;
		z-index: 2;
		font-size: 13px;
		color: #212121;

		div {
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
		}

		.sidebar-img {
			width: 26px;
			height: 26px;
			margin: 28px 0 4px;
		}

		.red {
			width: 20px;
			height: 20px;
			line-height: 20px;
			text-align: center;
			border-radius: 50px;
			position: absolute;
			top: 20px;
			right: -10px;
			background: #FA5151;
			color: #fff;
		}
	}


	.tit {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 18px;

		.operation {
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				width: 15px;
				height: 15px;
				margin-left: 20px;
			}
		}
	}

	.chat {
		margin-top: 20px;
		width: 100%;
	}
</style>